/* StudioSoie · Événements commerciaux — compte à rebours (fin en secondes epoch, fuseau boutique) et copie du code promo. */
(function () {
  'use strict';
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function tick() {
    var now = Date.now() / 1000;
    document.querySelectorAll('[data-ss-countdown]').forEach(function (el) {
      var end = parseInt(el.getAttribute('data-ss-countdown'), 10) || 0;
      var left = Math.max(0, end - now);
      var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]');
      if (left <= 0) {
        if (!el.classList.contains('is-ended')) { el.classList.add('is-ended'); var v = el.querySelector('.ss-evbar__count-val, .ss-evban__count-val'); if (v) { v.textContent = el.getAttribute('data-ended') || ''; } var l = el.querySelector('.ss-evbar__count-label, .ss-evban__count-label'); if (l) { l.hidden = true; } }
        return;
      }
      var days = Math.floor(left / 86400), hours = Math.floor((left % 86400) / 3600), mins = Math.floor((left % 3600) / 60);
      if (d) { d.textContent = String(days); }
      if (h) { h.textContent = pad(hours); }
      if (m) { m.textContent = pad(mins); }
    });
  }
  if (document.querySelector('[data-ss-countdown]')) { tick(); setInterval(tick, 15000); }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ss-copy]');
    if (!btn) { return; }
    var code = btn.getAttribute('data-ss-copy') || '';
    function done() {
      var b = btn.querySelector('b'), old = b ? b.textContent : '';
      btn.classList.add('is-copied');
      if (b) { b.textContent = btn.getAttribute('data-copied') || 'OK'; }
      setTimeout(function () { btn.classList.remove('is-copied'); if (b) { b.textContent = old; } }, 1800);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(done, done); }
    else { try { var ta = document.createElement('textarea'); ta.value = code; ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); ta.remove(); } catch (err) {} done(); }
  });
})();
